import { IconPropsType } from '..';

export const ReferralIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M91.3123 27.0312H98.1627C97.6303 26.416 97.0742 25.8244 96.4945 25.2565H89.7741C90.2947 25.8362 90.8153 26.4278 91.3123 27.0312Z"
      fill="url(#paint0_linear_2142_178483)"
    />
    <path
      d="M34.4616 74.7717H73.695V70.9738H72.0623H36.047H34.4616V74.7717Z"
      fill="url(#paint1_linear_2142_178483)"
    />
    <path
      d="M87.9285 100.553H83.6573C83.6573 100.553 83.6218 100.553 83.5982 100.553C80.6994 102.812 77.5522 104.729 74.1921 106.232C79.256 104.954 83.8466 103.037 87.9285 100.564V100.553Z"
      fill="url(#paint2_linear_2142_178483)"
    />
    <path
      d="M106.682 76.2625C108.208 71.305 109.013 65.8625 109.013 60.0059C109.013 57.5804 108.894 55.2496 108.669 53.0016H102.422C102.493 53.5458 102.564 54.1019 102.612 54.6462C102.635 54.8473 102.647 55.0484 102.671 55.2496C102.718 55.8293 102.765 56.4209 102.801 57.0125C102.813 57.2373 102.825 57.4503 102.836 57.6751C102.872 58.4559 102.896 59.225 102.896 60.0177C102.896 60.8104 102.872 61.5676 102.836 62.3485C102.836 62.5615 102.813 62.7745 102.801 62.9874C102.765 63.5908 102.73 64.1824 102.671 64.774C102.659 64.9633 102.635 65.1408 102.623 65.3301C102.47 66.9155 102.245 68.4773 101.949 70.0272C101.949 70.0864 101.925 70.1574 101.914 70.2165C101.511 72.287 101.003 74.3102 100.364 76.2743H106.694L106.682 76.2625Z"
      fill="url(#paint3_linear_2142_178483)"
    />
    <path
      d="M108.433 51.0257C108.338 50.3277 108.232 49.6414 108.113 48.9552H101.724C101.783 49.2628 101.854 49.5586 101.913 49.8662C101.913 49.8899 101.913 49.9136 101.925 49.9491C101.996 50.304 102.055 50.6708 102.115 51.0257H108.421H108.433Z"
      fill="url(#paint4_linear_2142_178483)"
    />
    <path
      d="M71.3285 68.9861L76.2977 52.7532L65.5073 59.1185C65.0341 59.3907 64.4306 59.2369 64.1585 58.7754L53.5811 41.0162L43.5834 58.7518C43.4533 58.9884 43.2285 59.154 42.9682 59.225C42.7079 59.296 42.4358 59.2487 42.1991 59.1067L32.1068 52.8123L36.7921 68.9861H71.3285Z"
      fill="url(#paint5_linear_2142_178483)"
    />
    <path
      d="M54.788 100.351C75.5524 100.351 92.4479 82.2492 92.4479 60.0058C92.4479 37.7625 75.5524 19.6602 54.788 19.6602C34.0236 19.6602 17.1163 37.7625 17.1163 60.0058C17.1163 82.2492 34.0118 100.351 54.788 100.351ZM29.8471 49.8188C30.1783 49.5704 30.6161 49.5467 30.9711 49.7715L42.3767 56.8823L52.7057 38.5552C52.8831 38.2476 53.2026 38.0582 53.5575 38.0464C53.9361 38.0701 54.2438 38.2239 54.4212 38.5315L65.3654 56.9059L77.5046 49.7478C77.8596 49.5467 78.2973 49.5704 78.6168 49.8188C78.9362 50.0673 79.0664 50.4932 78.9481 50.8837L73.4109 68.9741H74.7005C75.2448 68.9741 75.6944 69.4237 75.6944 69.968V75.7536C75.6944 76.2979 75.2566 76.7475 74.7005 76.7475H33.4794C32.9351 76.7475 32.4855 76.3097 32.4855 75.7536V69.968C32.4855 69.4237 32.9233 68.9741 33.4794 68.9741H34.7335L29.4921 50.8718C29.3738 50.4814 29.5158 50.0555 29.8471 49.807V49.8188Z"
      fill="url(#paint6_linear_2142_178483)"
    />
    <path
      className="mix-blend-screen"
      d="M17.1163 60.0058C17.1163 63.9102 17.6487 67.6845 18.6189 71.2576C18.9975 71.2576 19.3643 71.2813 19.7429 71.2813C24.3336 71.2813 28.7467 70.5477 32.8878 69.2108C33.0534 69.0806 33.2546 68.9978 33.4794 68.9978H33.5267C33.8935 68.8677 34.2602 68.7494 34.627 68.6192L29.4921 50.8955C29.3738 50.5051 29.5158 50.0791 29.8471 49.8307C30.1783 49.5822 30.6161 49.5585 30.9711 49.7833L42.3767 56.8941L52.7057 38.567C52.8831 38.2594 53.2026 38.0701 53.5575 38.0583C53.9361 38.0819 54.2438 38.2357 54.4212 38.5434L58.7516 45.8198C61.0587 40.5784 62.3484 34.7927 62.3484 28.6995C62.3484 25.8244 62.0644 23.0322 61.5202 20.3227C59.3432 19.8968 57.0952 19.672 54.7998 19.672C34.0354 19.672 17.1281 37.7743 17.1281 60.0177L17.1163 60.0058Z"
      fill="url(#paint7_linear_2142_178483)"
    />
    <path
      d="M31.2906 100.269L35.0767 97.642C35.3843 97.4172 35.7984 97.4054 36.1297 97.5947C36.461 97.784 36.6503 98.1508 36.6266 98.5294C36.6266 98.5294 36.4728 100.553 36.248 103.286C42.4123 106.516 49.0379 108.16 55.9476 108.16C56.7285 108.16 57.5093 108.137 58.2784 108.101C58.2784 108.101 58.3494 108.101 58.3849 108.101C59.1066 108.054 59.8283 108.007 60.5382 107.924C60.5619 107.924 60.5856 107.924 60.6092 107.924C80.1668 105.759 96.0329 90.1172 99.9729 69.8497C99.9729 69.8024 99.9965 69.7432 100.008 69.6959C100.138 69.0215 100.245 68.3353 100.351 67.649C100.363 67.5307 100.387 67.4242 100.411 67.3059C100.505 66.6788 100.576 66.0399 100.635 65.3892C100.647 65.2235 100.683 65.0579 100.695 64.8923C100.754 64.277 100.789 63.6499 100.825 63.0229C100.825 62.8336 100.848 62.6561 100.86 62.4668C100.896 61.6622 100.919 60.8459 100.919 60.0295C100.919 59.2131 100.896 58.3967 100.86 57.5922C100.86 57.4029 100.837 57.2254 100.825 57.0361C100.789 56.409 100.754 55.782 100.695 55.1667C100.683 55.0011 100.659 54.8354 100.635 54.6698C100.564 54.0309 100.493 53.392 100.411 52.7531C100.399 52.6348 100.375 52.5164 100.351 52.41C100.245 51.7237 100.138 51.0493 100.008 50.3631C100.008 50.3158 99.9847 50.2566 99.9729 50.2093C96.0211 29.9181 80.155 14.2768 60.5974 12.1116C60.5737 12.1116 60.5501 12.1116 60.5264 12.1116C59.8165 12.0406 59.0948 11.9815 58.3731 11.9342C58.3376 11.9342 58.3021 11.9342 58.2666 11.9342C57.4975 11.8868 56.7166 11.875 55.9357 11.875C51.215 11.875 46.5533 12.6677 42.0691 14.2177C42.5306 17.0336 42.9092 19.2934 42.9565 19.6128C46.6953 18.3705 50.6589 17.6961 54.7763 17.6961C76.641 17.6961 94.4238 36.6858 94.4238 60.0295C94.4238 83.3732 76.641 102.351 54.7763 102.351C32.9115 102.351 15.1405 83.3495 15.1405 60.0058C15.1405 41.8444 25.9072 26.3213 40.9806 20.3227L35.9404 16.8561C20.7605 24.9607 10.9758 41.8207 10.9758 60.0058C10.9758 76.3097 18.5598 91.3122 31.2906 100.269Z"
      fill="url(#paint8_linear_2142_178483)"
    />
    <path
      d="M92.8505 29.0072C96.7194 34.2604 99.6181 40.3418 101.286 46.9793H107.746C106.291 39.9987 103.605 33.9646 99.7719 28.9717C99.7009 28.9835 99.63 29.019 99.559 29.019H92.8505V29.0072Z"
      fill="url(#paint9_linear_2142_178483)"
    />
    <path
      d="M73.1389 13.3303C78.6524 15.6493 83.6572 19.045 87.9047 23.2688H94.3766C88.7802 18.4416 81.6458 15.0814 73.1389 13.3303Z"
      fill="url(#paint10_linear_2142_178483)"
    />
    <path
      d="M99.1094 79.7409H105.463C105.664 79.244 105.853 78.7589 106.031 78.2501H99.6892C99.5117 78.747 99.3106 79.244 99.1212 79.7409H99.1094Z"
      fill="url(#paint11_linear_2142_178483)"
    />
    <path
      d="M98.2928 81.6694C95.9738 86.8517 92.8384 91.5251 89.0641 95.536H94.6368C98.837 91.6908 102.209 87.0528 104.623 81.7168H98.5294C98.4466 81.7168 98.3638 81.6931 98.2928 81.6694Z"
      fill="url(#paint12_linear_2142_178483)"
    />
    <path
      d="M87.1357 97.4883C86.7453 97.8551 86.3548 98.2218 85.9526 98.5649H90.8982C91.3714 98.2218 91.8447 97.8669 92.2943 97.5119H87.254C87.254 97.5119 87.1712 97.4883 87.1239 97.4883H87.1357Z"
      fill="url(#paint13_linear_2142_178483)"
    />
    <path
      d="M29.4925 50.8838L34.7339 68.9861H33.4798C32.9355 68.9861 32.4859 69.4357 32.4859 69.9799V75.7656C32.4859 76.3098 32.9237 76.7594 33.4798 76.7594H74.6891C75.2334 76.7594 75.683 76.3216 75.683 75.7656V69.9799C75.683 69.4357 75.2452 68.9861 74.6891 68.9861H73.3995L78.9367 50.8956C79.055 50.5052 78.9248 50.0792 78.6054 49.8308C78.2859 49.5823 77.8363 49.5468 77.4932 49.7598L65.354 56.9179L54.4098 38.5434C54.2324 38.2358 53.9247 38.082 53.5461 38.0583C53.1912 38.0583 52.8717 38.2595 52.6942 38.5671L42.3653 56.8942L30.9597 49.7834C30.6165 49.5705 30.1669 49.5941 29.8357 49.8308C29.5044 50.0792 29.3624 50.5052 29.4807 50.8956L29.4925 50.8838ZM73.7071 70.9619V74.7599H34.4618V70.9619H73.6953H73.7071ZM42.2115 59.1067C42.4363 59.2487 42.7202 59.296 42.9805 59.225C43.2408 59.154 43.4656 58.9884 43.5958 58.7518L53.5934 41.0162L64.1709 58.7754C64.4548 59.2369 65.0582 59.4025 65.5197 59.1185L76.3101 52.7532L71.3408 68.9861H36.8045L32.1192 52.8123L42.2115 59.1067Z"
      fill="#C95F36"
    />
    <path
      d="M30.7346 102.28C31.0777 102.517 31.5155 102.505 31.8586 102.28L34.497 100.446C34.426 101.357 34.3314 102.505 34.2249 103.771C34.1894 104.161 34.3905 104.54 34.7337 104.717C41.3593 108.314 48.4938 110.124 55.9358 110.124C56.7522 110.124 57.5568 110.101 58.3613 110.065C71.6718 110.065 83.0065 106.634 91.7263 100.47C91.8683 100.411 91.9866 100.328 92.0931 100.21C104.09 91.537 111 77.5757 111 60.0058C111 28.2026 91.8092 9.95831 58.3613 9.94648C57.5568 9.89915 56.7522 9.87549 55.9358 9.87549C50.7181 9.87549 45.5595 10.7984 40.614 12.6204C40.1644 12.7861 39.9041 13.2475 39.975 13.7089C40.2235 15.2115 40.4483 16.6077 40.6376 17.6962L36.5676 14.8921C36.2718 14.6791 35.8813 14.6554 35.55 14.8329C19.4236 23.1505 9 40.886 9 60.0058C9 77.2089 17.1283 93.0041 30.7346 102.28ZM108.444 51.0139H102.138C102.079 50.6589 102.02 50.2921 101.949 49.9372C101.949 49.9135 101.949 49.8899 101.937 49.8544C101.878 49.5467 101.819 49.2391 101.748 48.9433H108.137C108.255 49.6296 108.362 50.3158 108.456 51.0139H108.444ZM105.475 79.7291H99.1211C99.3222 79.2321 99.5115 78.7352 99.689 78.2383H106.031C105.853 78.7471 105.664 79.2321 105.463 79.7291H105.475ZM90.9218 98.5649H85.9762C86.3785 98.21 86.7689 97.855 87.1593 97.4883C87.2067 97.4883 87.2422 97.5119 87.2895 97.5119H92.3297C91.8683 97.8669 91.4069 98.2218 90.9336 98.5649H90.9218ZM74.2038 106.22C77.5639 104.706 80.7111 102.789 83.6099 100.541C83.6335 100.541 83.6454 100.541 83.669 100.541H87.9402C83.8583 103.025 79.2677 104.942 74.2038 106.208V106.22ZM94.6606 95.5361H89.0879C92.8622 91.5252 95.9857 86.8399 98.3165 81.6695C98.3993 81.6931 98.4703 81.7168 98.5532 81.7168H104.646C102.233 87.0528 98.8726 91.7026 94.6606 95.5361ZM106.705 76.2624H100.375C101.002 74.2984 101.523 72.2752 101.925 70.2047C101.937 70.1455 101.949 70.0745 101.961 70.0154C102.256 68.4773 102.481 66.9037 102.635 65.3182C102.659 65.1289 102.671 64.9514 102.682 64.7621C102.73 64.1706 102.777 63.5672 102.813 62.9756C102.824 62.7626 102.836 62.5496 102.848 62.3367C102.884 61.5676 102.907 60.7867 102.907 60.0058C102.907 59.225 102.884 58.4441 102.848 57.6632C102.848 57.4384 102.824 57.2254 102.813 57.0006C102.777 56.4091 102.742 55.8293 102.682 55.2377C102.671 55.0366 102.647 54.8355 102.623 54.6343C102.564 54.0901 102.505 53.534 102.434 52.9897H108.681C108.906 55.2377 109.024 57.5804 109.024 59.994C109.024 65.8506 108.22 71.2932 106.693 76.2506L106.705 76.2624ZM101.298 46.9675C99.6298 40.3418 96.7311 34.2485 92.8622 28.9953H99.5707C99.6417 28.9953 99.7126 28.9716 99.7836 28.948C103.617 33.9409 106.303 39.975 107.758 46.9556H101.298V46.9675ZM91.3359 27.0194C90.839 26.416 90.3302 25.8244 89.7978 25.2447H96.5181C97.0979 25.8244 97.6539 26.416 98.1864 27.0194H91.3359ZM94.4003 23.257H87.9284C83.669 19.0331 78.6761 15.6375 73.1626 13.3185C81.6813 15.0695 88.8039 18.4297 94.4003 23.257ZM54.8118 19.6484C75.5762 19.6484 92.4717 37.7507 92.4717 59.994C92.4717 82.2374 75.5762 100.34 54.8118 100.34C34.0474 100.34 17.1165 82.2492 17.1165 60.0058C17.1165 37.7625 34.0119 19.6602 54.7882 19.6602L54.8118 19.6484ZM35.976 16.8561L41.0162 20.3228C25.9073 26.3214 15.1406 41.8444 15.1406 60.0058C15.1406 83.3377 32.9234 102.327 54.7882 102.327C76.6529 102.327 94.4358 83.3377 94.4358 60.0058C94.4358 36.674 76.6411 17.6843 54.7882 17.6843C50.6708 17.6843 46.7072 18.3587 42.9684 19.601C42.9211 19.2816 42.5425 17.0099 42.0811 14.2058C46.5652 12.6441 51.2269 11.8632 55.9477 11.8632C56.7286 11.8632 57.5094 11.8869 58.2785 11.9223C58.314 11.9223 58.3495 11.9223 58.385 11.9223C59.1067 11.9697 59.8284 12.017 60.5383 12.0998C60.562 12.0998 60.5856 12.0998 60.6093 12.0998C80.1669 14.265 96.033 29.9063 99.9729 50.1738C99.9729 50.2211 99.9966 50.2803 100.008 50.3276C100.139 51.002 100.245 51.6883 100.352 52.3745C100.363 52.4928 100.387 52.5993 100.411 52.7176C100.505 53.3447 100.576 53.9836 100.636 54.6343C100.647 54.8 100.683 54.9656 100.695 55.1312C100.754 55.7465 100.789 56.3736 100.825 57.0006C100.825 57.1899 100.848 57.3674 100.86 57.5567C100.896 58.3613 100.919 59.1776 100.919 59.994C100.919 60.8104 100.896 61.6268 100.86 62.4313C100.86 62.6206 100.837 62.7981 100.825 62.9874C100.789 63.6145 100.754 64.2416 100.695 64.8568C100.683 65.0224 100.659 65.1881 100.636 65.3537C100.565 65.9926 100.494 66.6315 100.411 67.2704C100.399 67.3887 100.375 67.5071 100.352 67.6135C100.245 68.2998 100.139 68.986 100.008 69.6604C100.008 69.7077 99.9848 69.7669 99.9729 69.8142C96.033 90.0817 80.1551 105.723 60.6093 107.888C60.5856 107.888 60.562 107.888 60.5383 107.888C59.8284 107.959 59.1067 108.018 58.385 108.066C58.3495 108.066 58.314 108.066 58.2785 108.066C57.5094 108.113 56.7286 108.125 55.9477 108.125C49.0499 108.125 42.4242 106.492 36.2481 103.25C36.4729 100.517 36.6267 98.4939 36.6267 98.4939C36.6622 98.1153 36.4611 97.7486 36.1298 97.5592C35.7985 97.3699 35.3844 97.3818 35.0768 97.6066L31.2907 100.233C18.5599 91.3122 10.9759 76.3098 10.9759 60.0058C10.9759 41.8207 20.7606 24.9607 35.9523 16.8679L35.976 16.8561Z"
      fill="#C95F36"
    />
    <path
      d="M29.5867 38.9456C30.5569 37.1591 32.2607 35.2542 34.3667 33.5859C37.2181 31.3143 40.4244 29.8472 42.5186 29.8472C43.0156 29.8472 43.6663 29.93 43.9857 30.3441C44.4472 30.9238 44.2342 32.1543 43.4297 33.6333C42.4595 35.4198 40.7557 37.3247 38.6497 38.993C35.7983 41.2646 32.5919 42.7199 30.4978 42.7199C30.0008 42.7199 29.3501 42.6371 29.0188 42.2348C28.5574 41.6551 28.7703 40.4246 29.5749 38.9456H29.5867Z"
      fill="white"
    />
    <path
      d="M22.6652 66.5013L24.4281 70.7015L28.6283 72.4645L24.4281 74.2392L22.6652 78.4394L20.9023 74.2392L16.7021 72.4645L20.9023 70.7015L22.6652 66.5013Z"
      fill="white"
    />
    <path
      d="M72.9026 20.8315L74.6655 25.0318L78.8657 26.7947L74.6655 28.5694L72.9026 32.7578L71.1278 28.5694L66.9395 26.7947L71.1278 25.0318L72.9026 20.8315Z"
      fill="white"
    />
    <path
      d="M54.4335 11.9223C71.6721 11.9223 86.6982 21.4112 94.5898 35.4317C87.4909 22.6772 75.0559 13.7089 60.5977 12.1116C60.5741 12.1116 60.5504 12.1116 60.5267 12.1116C59.8168 12.0406 59.0951 11.9815 58.3734 11.9342C58.3379 11.9342 58.3024 11.9342 58.2669 11.9342C57.4978 11.8868 56.717 11.875 55.9361 11.875C54.9895 11.875 54.0549 11.9223 53.1202 11.9815C53.5579 11.9815 53.9839 11.946 54.4216 11.946L54.4335 11.9223Z"
      fill="#AE4736"
    />
    <path
      d="M100.849 57.5685C100.849 57.3792 100.825 57.2017 100.813 57.0124C100.778 56.3853 100.742 55.7583 100.683 55.143C100.671 54.9774 100.648 54.8117 100.624 54.6461C100.553 54.0072 100.482 53.3683 100.399 52.7294C100.387 52.6111 100.364 52.4928 100.34 52.3863C100.233 51.7 100.127 51.0256 99.9968 50.3394C99.9968 50.2921 99.9732 50.2329 99.9613 50.1856C99.4289 47.4643 98.6835 44.8259 97.737 42.2821C99.5117 47.1804 100.482 52.4691 100.482 57.9826C100.482 83.4205 79.8595 104.043 54.4216 104.043C48.0562 104.043 41.9866 102.753 36.4731 100.411C36.414 101.191 36.3311 102.174 36.2365 103.286C42.4007 106.516 49.0264 108.16 55.9361 108.16C56.7169 108.16 57.4978 108.137 58.2669 108.101C58.2669 108.101 58.3379 108.101 58.3734 108.101C59.0951 108.054 59.8168 108.006 60.5267 107.924C60.5504 107.924 60.574 107.924 60.5977 107.924C80.1553 105.758 96.0214 90.1171 99.9613 69.8497C99.9613 69.8023 99.985 69.7432 99.9968 69.6959C100.127 69.0215 100.233 68.3352 100.34 67.649C100.352 67.5307 100.375 67.4242 100.399 67.3059C100.494 66.6788 100.565 66.0399 100.624 65.3892C100.636 65.2235 100.671 65.0579 100.683 64.8922C100.742 64.277 100.778 63.6499 100.813 63.0228C100.813 62.8335 100.837 62.6561 100.849 62.4668C100.884 61.6622 100.908 60.8458 100.908 60.0295C100.908 59.2131 100.884 58.3967 100.849 57.5922V57.5685Z"
      fill="#AE4736"
    />
    <path
      d="M18.8675 87.2539C22.1212 92.3296 26.3096 96.7665 31.2789 100.269L33.2666 98.8962C27.7057 96.0211 22.8075 92.0457 18.8675 87.2657V87.2539Z"
      fill="#AE4736"
    />
    <path
      d="M97.5476 41.7733C97.4057 41.4184 97.2637 41.0516 97.1217 40.6967C97.2637 41.0516 97.4057 41.4065 97.5476 41.7733Z"
      fill="#AE4736"
    />
    <path
      d="M96.5771 39.407C96.5416 39.3361 96.5061 39.2651 96.4706 39.1823C96.5061 39.2532 96.5416 39.3242 96.5771 39.407Z"
      fill="#AE4736"
    />
    <path
      className="mix-blend-screen"
      d="M19.9322 60.6802C19.9322 38.6498 37.786 20.796 59.8283 20.796C61.4965 20.796 63.1411 20.9143 64.762 21.1154C61.5793 20.1808 58.2428 19.672 54.788 19.672C34.0236 19.672 17.1163 37.7743 17.1163 60.0177C17.1163 82.261 34.0118 100.363 54.788 100.363C55.0246 100.363 55.2494 100.351 55.4861 100.34C35.5026 98.1745 19.944 81.2553 19.944 60.6921L19.9322 60.6802Z"
      fill="url(#paint14_linear_2142_178483)"
    />
    <path
      className="mix-blend-multiply"
      opacity="0.4"
      d="M84.012 34.5798C87.6206 40.7086 89.703 47.843 89.703 55.4744C89.703 78.2502 71.2339 96.7192 48.4581 96.7192C43.9148 96.7192 39.5371 95.9739 35.4552 94.6132C41.1107 98.2573 47.7246 100.352 54.788 100.352C75.5524 100.352 92.4479 82.2492 92.4479 60.0059C92.4479 50.375 89.277 41.525 84.0002 34.5798H84.012Z"
      fill="url(#paint15_linear_2142_178483)"
    />
    <path
      className="mix-blend-multiply"
      opacity="0.4"
      d="M57.7106 47.9731L53.5695 41.028L43.5719 58.7635C43.4417 59.0001 43.2169 59.1658 42.9566 59.2367C42.6963 59.3077 42.4242 59.2604 42.1876 59.1184L32.0952 52.824L36.4493 67.8738C45.6542 63.9339 53.1791 56.8468 57.6988 47.9731H57.7106Z"
      fill="url(#paint16_linear_2142_178483)"
    />
    <g className="mix-blend-screen">
      <path
        d="M15.1407 60.0058C15.1407 41.8444 25.9075 26.3213 40.9809 20.3227L35.9406 16.8561C20.7607 24.9607 10.976 41.8207 10.976 60.0058C10.976 63.6144 11.3665 67.1521 12.0882 70.5832C13.5553 70.8435 15.0342 71.0447 16.5487 71.1511C15.6377 67.6017 15.1407 63.8629 15.1407 60.0058Z"
        fill="url(#paint17_linear_2142_178483)"
      />
      <path
        d="M42.9686 19.601C46.7074 18.3587 50.671 17.6843 54.7884 17.6843C56.9062 17.6843 59.0004 17.8736 61.0354 18.2167C60.4912 16.0634 59.7813 13.981 58.9294 11.9815C58.7519 11.9697 58.5745 11.946 58.3852 11.9342C58.3497 11.9342 58.3142 11.9342 58.2787 11.9342C57.5096 11.8868 56.7287 11.875 55.9479 11.875C51.2271 11.875 46.5654 12.6677 42.0813 14.2177C42.5427 17.0336 42.9213 19.2934 42.9686 19.6128V19.601Z"
        fill="url(#paint18_linear_2142_178483)"
      />
    </g>
    <path
      d="M87.3843 78.5341L88.4846 81.1607L91.1112 82.261L88.4846 83.3732L87.3843 85.988L86.2839 83.3732L83.6573 82.261L86.2839 81.1607L87.3843 78.5341Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2142_178483"
        x1="93.9744"
        y1="27.0312"
        x2="93.9744"
        y2="25.2446"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.16"
          stopColor="#FF8F22"
        />
        <stop
          offset="1"
          stopColor="#E54522"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2142_178483"
        x1="54.0783"
        y1="48.5411"
        x2="54.0783"
        y2="83.6217"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.16"
          stopColor="#FF8F22"
        />
        <stop
          offset="1"
          stopColor="#E54522"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2142_178483"
        x1="81.0662"
        y1="106.22"
        x2="81.0662"
        y2="100.541"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D29233" />
        <stop
          offset="0.77"
          stopColor="#FFDA33"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2142_178483"
        x1="104.694"
        y1="76.2625"
        x2="104.694"
        y2="53.0016"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D29233" />
        <stop
          offset="0.77"
          stopColor="#FFDA33"
        />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2142_178483"
        x1="105.084"
        y1="51.0257"
        x2="105.084"
        y2="48.9552"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.16"
          stopColor="#FF8F22"
        />
        <stop
          offset="1"
          stopColor="#E54522"
        />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2142_178483"
        x1="54.2082"
        y1="48.5411"
        x2="54.2082"
        y2="83.6099"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.16"
          stopColor="#FF8F22"
        />
        <stop
          offset="1"
          stopColor="#E54522"
        />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2142_178483"
        x1="54.788"
        y1="100.351"
        x2="54.788"
        y2="19.6602"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D29233" />
        <stop
          offset="0.77"
          stopColor="#FFDA33"
        />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2142_178483"
        x1="17.1163"
        y1="45.4648"
        x2="62.3366"
        y2="45.4648"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.16"
          stopColor="#FF8F22"
        />
        <stop
          offset="1"
          stopColor="#E54522"
        />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2142_178483"
        x1="55.9476"
        y1="11.8513"
        x2="55.9476"
        y2="108.16"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.16"
          stopColor="#FF8F22"
        />
        <stop
          offset="1"
          stopColor="#E54522"
        />
      </linearGradient>
      <linearGradient
        id="paint9_linear_2142_178483"
        x1="100.293"
        y1="46.9675"
        x2="100.293"
        y2="28.9598"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D29233" />
        <stop
          offset="0.77"
          stopColor="#FFDA33"
        />
      </linearGradient>
      <linearGradient
        id="paint10_linear_2142_178483"
        x1="83.7518"
        y1="23.2688"
        x2="83.7518"
        y2="13.3303"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D29233" />
        <stop
          offset="0.77"
          stopColor="#FFDA33"
        />
      </linearGradient>
      <linearGradient
        id="paint11_linear_2142_178483"
        x1="102.576"
        y1="79.7409"
        x2="102.576"
        y2="78.2501"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.16"
          stopColor="#FF8F22"
        />
        <stop
          offset="1"
          stopColor="#E54522"
        />
      </linearGradient>
      <linearGradient
        id="paint12_linear_2142_178483"
        x1="96.8493"
        y1="95.536"
        x2="96.8493"
        y2="81.6694"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D29233" />
        <stop
          offset="0.77"
          stopColor="#FFDA33"
        />
      </linearGradient>
      <linearGradient
        id="paint13_linear_2142_178483"
        x1="89.1353"
        y1="98.5768"
        x2="89.1353"
        y2="97.4883"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.16"
          stopColor="#FF8F22"
        />
        <stop
          offset="1"
          stopColor="#E54522"
        />
      </linearGradient>
      <linearGradient
        id="paint14_linear_2142_178483"
        x1="17.1163"
        y1="60.0058"
        x2="64.762"
        y2="60.0058"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D29233" />
        <stop
          offset="0.77"
          stopColor="#FFDA33"
        />
      </linearGradient>
      <linearGradient
        id="paint15_linear_2142_178483"
        x1="63.9457"
        y1="100.352"
        x2="63.9457"
        y2="34.5798"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.16"
          stopColor="#FF8F22"
        />
        <stop
          offset="1"
          stopColor="#E54522"
        />
      </linearGradient>
      <linearGradient
        id="paint16_linear_2142_178483"
        x1="42.8738"
        y1="37.0525"
        x2="54.0546"
        y2="110.278"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.16"
          stopColor="#FF8F22"
        />
        <stop
          offset="1"
          stopColor="#E54522"
        />
      </linearGradient>
      <linearGradient
        id="paint17_linear_2142_178483"
        x1="10.976"
        y1="44.0095"
        x2="40.9927"
        y2="44.0095"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.16"
          stopColor="#FF8F22"
        />
        <stop
          offset="1"
          stopColor="#E54522"
        />
      </linearGradient>
      <linearGradient
        id="paint18_linear_2142_178483"
        x1="42.0813"
        y1="15.7321"
        x2="61.0354"
        y2="15.7321"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.16"
          stopColor="#FF8F22"
        />
        <stop
          offset="1"
          stopColor="#E54522"
        />
      </linearGradient>
    </defs>
  </svg>
);
